import * as yup from "yup";
import selectOptionsData from '../selectoptionsdata/selectoptionsdata.json';


export const getFields = () => {
    const hostConfigFields = [
        { name: "slNo", label: "SL No" , readonly: true, hidden: true},
        { name: "tpdu", label: "TPDU", maxLength: 10 },
        { name: "terminalId", label: "Terminal Id", maxLength: 8 },
        { name: "merchantId", label: "Merchant ID" , maxLength: 15},
        { name: "label", label: "Label" },
        { name: "manualMode", label: "Manual Mode", type: "select", options: selectOptionsData.hostConfig.manualMode, default: "Normal Mode" },
        { name: "hostType", label: "Host Type", type: "select", options: selectOptionsData.hostConfig.hostType, default: "Host Type C" },
        { name: "hostCommsName", label: "Primary Ip" , placeholder: "e.g. 192.168.0.1"},
        { name: "primaryIpPort", label: "Primary Ip Port", type: 'number', maxLength: 5 },
        { name: "hostCommsBackup", label: "Secondary Ip", placeholder: "e.g. 192.168.0.1" },
        { name: "secondaryIpPort", label: "Secondary Ip Port", type: 'number', maxLength: 5 },
        { name: "bankMasterSlNo", label: "TLE Key ID", type: "select", options: [] },
        { name: "tieEnable", label: "TLE Enable", type: "select", options: selectOptionsData.enableDisableOptions, default: false },
        { name: "tieKeyLoadingEnable", label: "TLE Loading Enable", type: "select", options: selectOptionsData.enableDisableOptions, default: false },
        { name: "currency", label: "Currency", type: "select", options: selectOptionsData.hostConfig.currencyType },
        { name: "theBitmap", label: "TLE Bitmap", type: 'text', maxLength: 16 },
        { name: "settleOption", label: "Settle Option", type: "select", options: selectOptionsData.hostConfig.settleOption, default: "Normal" },
        { name: "settleTime", label: "Settle Time", type: 'number', maxLength: 4 },
        { name: "schemes", label: "Card Config", type: "select", multiple: true, options: [] },
        { name: "isTLSEnable", label: "TLS Enable", type: "select", options: selectOptionsData.enableDisableOptions, default: false },
        { name: "bankName", label: "Bank TLS Config", type: "select", options: [], // will populate from API
          visible: true },
    ];

    const cardConfigFields = [
        { name: "slNo", label: "SL No", readonly: true,hidden: true },
        { name: "configName", label: "Config Name",type: 'text'},
        { name: "cardLabel", label: "Card Label", type: "select", options: selectOptionsData.cardConfig.cardScheme },
        { name: "lowPrefix", label: "Low Prefix", maxLength: 19 },
        { name: "highPrefix", label: "High Prefix", maxLength: 19 },
        { name: "panMinLength", label: "Pan Min Length" },
        { name: "panMaxLength", label: "Pan Max Length" },
        { name: "manualEntryEnabled", label: "Manual Enable", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "fallback_allow", label: "Fallback Allow", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "lnhnCheckRequired", label: "Luhn Check Required", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "preauthorize", label: "Preauthorize", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "docClassCVMLimit", label: "Doc Cless CVM Limit" },
        { name: "docClassEnabled", label: "Doc Cless Enabled", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "pinBypassEnabled", label: "Pin Bypass Enabled", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "receiptCustomerPanMask", label: "Receipt Customer Pan Mask", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "receiptCustomerExpiryDateMask", label: "Receipt Customer Expiry Date Mask",type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "receiptMerchantPanMask", label: "Receipt Merchant Pan Mask",type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "receiptMerchantExpiryDateMask", label: "Receipt Merchant Expiry Date Mask" ,type: "select", options: selectOptionsData.enableDisableOptions},
      //  { name: "evmVersionNumber", label: "Evm version number" },
      //  { name: "evmAdditionalCapability", label: "Evm additional capability" },
       // { name: "classTacOnline", label: "Class tac online" },
      //  { name: "classDenial", label: "Class denial" },
       // { name: "classTerminalCapability", label: "Class terminal capability" },
       // { name: "classTerminalCapability", label: "Class terminal capability" },
        { name: "fuelDe54Info", label: "Fuel De54 Info", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "fuelPrintInfo", label: "Fuel Print Info", type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "fuelLogic", label: "Fuel Logic", type: "select", options: selectOptionsData.cardConfig.fuelLogic },
        { name: "fuelSurchargePercentage", label: "Fuel Surcharge Percentage" },
        { name: "terminalWorkingKey", label: "Terminal Working Key", minLength: 32, maxLength: 32, type: "text"}
    ];

    const headerConfigFields = [
        { name: "slNo", label: "SL No", readonly: true,hidden: true },
        { name: "reciptHeaderLine1", label: "Receipt Header Line 1" },
        { name: "reciptHeaderLine2", label: "Receipt Header Line 2" },
        { name: "reciptHeaderLine3", label: "Receipt Header Line 3" },
        { name: "reciptHeaderLine4", label: "Receipt Header Line 4" },
        { name: "reciptLogo", label: "Receipt Logo (PNG/JPEG ≤ 1MB)", type: "file", accept: "image/png,image/jpeg" },
        { name: "hostReference", label: "Host Reference", type: "select",multiple:true, options: [] }
    ];
    const installmentConfigFields = [
        { name: "slNo", label: "SL No" , readonly: true,hidden: true},
        { name: "numberOfPayments", label: "Number of Payment", type: 'number', maxLength: 2 },
        { name: "tableNo", label: "Table No", type: 'number', maxLength: 2 },
        { name: "riskType", label: "Risk Type" , type: 'number', maxLength: 1},
        { name: "reserved", label: "Reserved" , type: 'number', maxLength: 6},
        { name: "paymentPlan", label: "Payment Plan", type: 'number', maxLength: 1 },
        { name: "hostReference", label: "Host reference", type: "select", multiple: true, options: [] }
    ];
    const currencyConfigFields = [
        { name: "slNo", label: "SL No", readonly: true ,hidden: true},
        { name: "currencyName", label: "Currency Name" },
        { name: "currencyCode", label: "Currency Code", type: 'number', maxLength: 4 },
        { name: "preauthEnabled", label: "Pre Auth enable",type: "select", options: selectOptionsData.enableDisableOptions },
        { name: "classCVMLimit", label: "Cless CVM Limit", type: 'number', maxLength: 8 },
        { name: "classFloorLimit", label: "Cless Floor Limit", type: 'number', maxLength: 8 },
        { name: "classTransactionLimit", label: "Cless Transaction Limit", type: 'number', maxLength: 8 },
        { name: "hostReference", label: "Host reference", type: "select", multiple: true, options: [] }
    ];

    const terminalConfigFields = [
      // { name: "currencyCode", label: "currency code", type: 'number', maxLength: 4 },
      // { name: "countryCode", label: "country code",type: 'number', maxLength: 4 },
      { name: "iin", label: "Institute Identification Number", type: "number", maxLength: 10 },
      { name: "fallbackTrying", label: "Fallback Trying", type: "number", maxLength: 1 },
      { name: "maxAmount", label: "Max Transaction Amount", type: "number", maxLength: 11, format: "amount" },
      { name: "minAmount", label: "Min Transaction Amount", type: "number", maxLength: 11, format: "amount" },
      { name: "contactlessEnabled", label: "Contactless Enabled", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "terminalMode", label: "Terminal Mode", type: "select", options: selectOptionsData.terminalConfig.terminalMode },
      { name: "txnFlowMode", label: "Txn Flow Mode", type: "select", options: selectOptionsData.terminalConfig.txnFlowMode },
      { name: "receiptPrintMode", label: "Reciept Print Mode", type: "select", options: selectOptionsData.terminalConfig.recieptPrintMode },
      { name: "dccEnabled", label: "DCC Enabled", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "dccOfferTimeout", label: "DCC Offer Timeout", type: "number", maxLength: 2 },
      // { name: "allowableTipPercentage", label: "allowable tip percentage"},
      // { name: "tipEnabled", label: "tip enabled",type: "select", options: selectOptionsData.enableDisableOptions },
      // { name: "currencyTipEnabled", label: "currency tip enabled",type: "select", options: selectOptionsData.enableDisableOptions },
      // { name: "tipAllowedForCup", label: "is tip allowed for cup",type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "ecrEnable", label: "ECR Enable", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "ecrMode", label: "ECR Eode", type: "select", options: selectOptionsData.terminalConfig.ecrMode },
      { name: "ecrMirror", label: "ECR Mirror", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "aggregatorModeEnable", label: "Aggregator Mode", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "allowablePreAuthConfirmPercentage", label: "Allowable Preauth Confirm Percentage", type: "number", maxLength: 3 },
      { name: "maxPreauthRecordsAllowed", label: "Max Preauth Records Allowed", type: "number", maxLength: 3 },
      { name: "maxPreauthHoldingDays", label: "Max Preauth Holding Days", type: "number", maxLength: 3 },
      { name: "merchantCategoryCode", label: "Merchant Category Code", type: "text" },
      { name: "merchantName", label: "Merchant Name", type: "text" },
      { name: "terminalType", label: "Terminal Type", type: "text" },
      { name: "syncTransaction", label: "Sync Transaction",type: "select",options: selectOptionsData.syncTransactionOptions  },
      { name: "debugMode", label: "Debug Mode",type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "forceSettlement", label: "Force Settlement", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "isoLog", label: "ISO Log", type: "select", options: selectOptionsData.enableDisableOptions },
      { name: "hostTimeOut", label: "Host Time Out (Second)", type: "number", }
    ];

    const transactionControlConfigFields = [
        { name: "saleCtrl", label: "Sale Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "voidCtrl", label: "Void Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "cupTraceCtrl", label: "Cup Trace Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "settlementCtrl", label: "Settlement Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "preauthCtrl", label: "Preauth Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "preauthManualCtrl", label: "Preauth Manual Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "cardVerifyCtrl", label: "Card Verify Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "authCtrl", label: "Auth Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        { name: "preauthConfirmCtrl", label: "Preauth Confirm Control",type: "switch",options: selectOptionsData.enableDisableOptions },
       // { name: "refundCtrl", label: "refund control",type: "select",options: selectOptionsData.enableDisableOptions },
        { name: "officeCtrl", label: "Office Control",type: "switch",options: selectOptionsData.enableDisableOptions },
       { name: "manualEntryCtrl", label: "Manual Entry Control",type: "switch",options: selectOptionsData.enableDisableOptions },
        // { name: "manualEntryCtrlCard", label: "manual entry control Card",type: "switch",options: selectOptionsData.enableDisableOptions },
      //  { name: "balanceEnquiryCtrl", label: "balance enquiry control",type: "select",options: selectOptionsData.enableDisableOptions },
        { name: "cashAdvanceCtrl", label: "Cash Advance Control",type: "switch",options: selectOptionsData.enableDisableOptions },
       // { name: "cashBackCtrl", label: "cash back control",type: "select",options: selectOptionsData.enableDisableOptions },
        { name: "installmentPaymentCtrl", label: "Installment Payment Control",type: "switch",options: selectOptionsData.enableDisableOptions },
      //  { name: "adjustCtrl", label: "adjust control",type: "select",options: selectOptionsData.enableDisableOptions },
       // { name: "tipCtrl", label: "tip control",type: "select",options: selectOptionsData.enableDisableOptions },
       // { name: "settleCtrl", label: "settle control",type: "select",options: selectOptionsData.enableDisableOptions },
    ];

    const transactionPasswordConfigFields = [
        { name: "voidPassword", label: "Void Password", type: "password", maxLength: 6 },
       // { name: "editorPassword", label: "editor password",type: "password" },
        { name: "deleteBatchPassword", label: "Delete Batch Password", type: "password", maxLength: 6 },
       // { name: "logonPassword", label: "logon password",type: "password" },
       // { name: "refundPassword", label: "refund password",type: "password" },
      //  { name: "adjustPassword", label: "adjust password",type: "password" },
        { name: "authPassword", label: "Auth Password", type: "password", maxLength: 6 },
       // { name: "balanceInqPassword", label: "balance inq password",type: "password" },
      //  { name: "officePassword", label: "Offline Password", type: "password", maxLength: 6 },
        { name: "settlementPassword", label: "Settlement Password", type: "password", maxLength: 6 },
       // { name: "manualEntryPassword", label: "Manual Entry Password", type: "password", maxLength: 6 },
        //{ name: "cashAdvancePassword", label: "Cash Advance Password", type: "password", maxLength: 6 },
        { name: "applicationPassword", label: "Application Password", type: "password", maxLength: 6 },
        { name: "completionPassword", label: "Pre Auth/Auth Completion Password", type: "password", maxLength: 6 },
         { name: "clearReversalPassword", label: "Clear Reversal Password", type: "password", maxLength: 6 },
        { name: "adminSettings", label: "Admin Settings Password", type: "password", maxLength: 6 },
        { name: "merchantSettings", label: "Merchant Settings Password", type: "password", maxLength: 6 }
    ];

    const evmParamsConfigFields = [
        { name: "slNo", label: "SL No", type: "text", readonly: true, hidden: true },
        { name: "evmScheme", label: "EMV Scheme", type: "select", options: selectOptionsData.emvConfig.emvScheme },
        { name: "evmAid", label: "EMV AID", type: "text" },
        { name: "evmTacDefault", label: "EMV TAC Default", type: "text" },
        { name: "evmTacDenial", label: "EMV TAC Denial", type: "text" },
        { name: "evmTacActCode", label: "EMV TAC Act Code", type: "text" },
        { name: "evmThresholdValue", label: "EMV Threshold Value", type: "text" },
      //  { name: "evmTargetPercentage", label: "Emv target percentage", type: "text" },
       // { name: "evmMaxTargetPer", label: "Emv max target percentage", type: "text" },
        { name: "evmDefaultDdol", label: "EMV Default DDOL", type: "text" },
        { name: "evmDefaultTdol", label: "EMV Default TDOL", type: "text" },
        { name: "evmAppVersion", label: "EMV APP Version", type: "text" },
        { name: "evmAcqIdentifier", label: "EMV ACQ Identifier", type: "text" },
        { name: "evmFloorLimit", label: "EMV Floor Limit", type: "text" },
       // { name: "evmTxnCategoryCode", label: "Emv txn category code", type: "text" },
       // { name: "evmAidTaxType", label: "Emv aid tax type", type: "text" },
       // { name: "evmCardLabel", label: "Emv card label", type: "text" },
        { name: "evmTransType", label: "EMV Trans Type", type: "text" },
        { name: "evmTransCurrency", label: "EMV Trans Currency", type: "text" },
        { name: "evmTransCapability", label: "EMV Trans Capability", type: "text" },
       // { name: "evmTransTerminalId", label: "Emv trans terminal Id", type: "text" },
        { name: "evmTxnCountryCode", label: "EMV TXN Country Code", type: "text" },
        { name: "evmTerminalType", label: "EMV Terminal Type", type: "text" },
        { name: "evmTerminalRiskMg", label: "EMV Terminal Risk Mgmt Data", type: "text" },
        { name: "evmVersionNo", label: "EMV Version No", type: "text" },
        { name: "evmAdditionalCapability", label: "EMV Additional Capabilities", type: "text" },
        { name: "classTacDefault", label: "Cless TAC Default", type: "text" },
        { name: "classTacOnline", label: "Cless TAC Online", type: "text" },
        { name: "classDenial", label: "Cless Denial", type: "text" },
        { name: "clessTransCapability", label: "Cless Trans Capability", type: "text" },
        { name: "tacOnline", label: "TAC Online", type: "text" },
        { name: "targetPercentage", label: "Target Percentage", type: "text" },
        { name: "maxTargetPercentage", label: "Max Target Percentage", type: "text" },
        // { name: "contactlessTransLimit", label: "Contactless TransLimit", type: "text" },
        // { name: "contactlessCVMLimit", label: "Contactless CVMLimit", type: "text" },
        // { name: "contactlessFloorLimit", label: "Contactless FloorLimit", type: "text" },
        { name: "dynamicTransLimit", label: "Dynamic TransLimit", type: "text" }
    ];

    const capkConfigFields = [
        { name: "slNo", label: "SL No", type: "text", readonly: true, hidden: true },
        { name: "capkScheme", label: "CAPK Scheme", type: "select", options: selectOptionsData.emvConfig.emvScheme },
        { name: "rid", label: "RID", type: "text" },
        { name: "capkIndex", label: "CAPK Index", type: "text" },
        { name: "exponent", label: "Exponent", type: "text" },
        { name: "module", label: "Module", type: "textarea" },
        { name: "checksum", label: "Checksum", type: "textarea" },
        { name: "algorithmInd", label: "Algorithm Ind", type: "select", options: [
            { label: "ALGO_IND_RSA = 1", value: "1" },
            { label: "ALGO_IND_SM = 4", value: "4" }
        ] },
        { name: "hashInd", label: "Hash Ind", type: "select", options: [
            { label: "HASH_IND_NOT = 0", value: "0" },
            { label: "HASH_IND_SHA1 = 1", value: "1" }
        ] }
    ];

    const deviceConfigFields = [
        { name: "slNo", label: "Serial Number",xs: 6, readonly: true, hidden: true },
        { name: "terminalBrand", label: "Terminal Brand",xs: 6 },
        { name: "terminalName", label: "Terminal Name" , xs: 6},
       // { name: "terminalId", label: "Terminal ID",xs: 6 },
        { name: "serialNumber", label: "Serial Number",xs: 6 },
        { name: "deviceStatus", label: "Device Status", type: "select", options: selectOptionsData.activeInactiveOptions,xs: 6 },
        { name: "grpId", label: "Select Group", type: "select", options: [],xs: 6, readonly:false },
        { name: "controlConfigSerialNumber", label: "Select Config", type: "select", options: [],xs: 6, readonly:false },
        { name: "grpIdText", label: "Group", type: "text", hidden: true, xs: 6, readonly: true },
        { name: "controlSerialNumberText", label: "Config", type: "text", hidden: true, xs: 6,readonly: true},
    ];

    const groupConfigFields = [
        { name: "slNo", label: "SL No", type: "text", xs: 6, readonly: true,hidden: true },
        { name: "grpConfigName", label: "Group Config Name", type: "text", xs: 6 },
        { name: "grpType", label: "Group Type", type: "text", xs: 6 },
        { name: "grpId", label: "Group Id", type: "text", xs: 6 }
    ];

    const controlConfigFields = [
        { name: "slNo", label: "SL No", type: "text", xs: 6, readonly: true,hidden: true },
        { name: "controlName", label: "Ctl Config Name", type: "text", xs: 6 },
        { name: "controlType", label: "Ctl Type", type: "select",placeholder: "Select control type", xs: 6, options: [] },
        { name: "controlId", label: "Org Id", type: "text", xs: 6 , readonly: true}
    ];

    // Validation schema for card config
    const cardConfigSchema = yup.object().shape({
      cardLabel: yup
        .string()
        .required("Card Label is required")
        .test("not-empty", "Card Label is required", (value) => value && value.trim().length > 0),

    //   manualEntryEnabled: yup
    //     .string()
    //     .required("Manual Entry selection is required")
    //     .test(
    //       "not-empty",
    //       "Manual Entry selection is required",
    //       (value) => value && value.trim().length > 0
    //     ),

    //  docClassCVMLimit: yup
    //     .string()
    //     .required("Please enter minimum value as "),

    //   fallBackAllow: yup
    //     .string()
    //     .required("Fallback selection is required")
    //     .test(
    //       "not-empty",
    //       "Fallback selection is required",
    //       (value) => value && value.trim().length > 0
    //     ),

      terminalWorkingKey: yup
        .string()
        .trim()
        .required("Terminal Working Key is required")
        .length(32, "TWK must be exactly 32 characters")
        .matches(/^[a-zA-Z0-9]+$/, "TWK must be alphanumeric with no spaces or special characters"),
    });

    // const cardConfigSchema = yup.object().shape({
    //   cardLabel: yup.string().trim().required("Card Label is required").min(1, "Please select a value"),
    //   manualEntryEnabled: yup.string().required("Select a value"),
    //   fallBackAllow: yup.string().required("Select a value"),
    //   terminalWorkingKey: yup
    //     .string()
    //     .trim()
    //     .required("Terminal Working Key is required")
    //     .length(32, "TWK must be exactly 32 characters")
    //     .matches(/^[a-zA-Z0-9]+$/, "TWK must be alphanumeric with no spaces or special characters"),
    // });
    
    const terminalValidationSchema = yup.object().shape({
      currencyCode: yup.string().matches(/^\d+$/, "Only digits allowed").max(4),
      defaultCurrency: yup.string().required("Default Currency is required"),
      hostTimeOut: yup.number().typeError("Host timeout must be a number")
    
      // countryCode: yup.string().matches(/^\d+$/, "Only digits allowed").max(3),
      // iin: yup.string().matches(/^\d+$/, "Only digits allowed").max(6),
      // fallbackTrying: yup.number().min(0).max(99),
      // maxTransaction: yup.number().min(0),
      // minTransaction: yup.number().min(0),
      // maxAmount: yup.number().min(0),
      // minAmount: yup.number().min(0),
      // // ... other validations
    });
    const hostConfigYupValidation = yup.object().shape({
        label: yup.string().trim().required("Label is required"),
        primaryIpPort: yup.string().required("Primary IP Port is required"),
        secondaryIpPort: yup.string().required("Secondary IP Port is required"),
        settleTime: yup.string().required("Settle Time is required"),
        theBitmap: yup
            .string()
            .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
            .max(16, "Maximum 4 characters"),
        hostCommsName: yup.string()
            .matches(
                /^(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/,
                "Must be a valid IPv4 address (e.g. 192.168.0.1)"
            ),
        hostCommsBackup: yup.string()
            .matches(
                /^(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/,
                "Must be a valid IPv4 address (e.g. 192.168.0.1)"
            ),
        tpdu: yup
            .string()
            .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
            .max(10, "Maximum 10 characters"),
        terminalId: yup
            .string()
            .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
            .max(8, "Maximum 8 characters"),
        merchantId: yup
            .string()
            .matches(/^[A-Za-z0-9]+$/, "Only alphanumeric characters allowed")
            .max(15, "Maximum 15 characters"),

    });

    return {
        hostConfigFields,
        cardConfigFields,
        headerConfigFields,
        cardConfigSchema,
        installmentConfigFields,
        currencyConfigFields,
        terminalConfigFields,
        transactionControlConfigFields,
        transactionPasswordConfigFields,
        evmParamsConfigFields,
        capkConfigFields,
        groupConfigFields,
        deviceConfigFields,
        controlConfigFields,
        terminalValidationSchema,
        hostConfigYupValidation
    };
};
